import React, { useState, useEffect, useRef } from "react";
import "./ChatAI.css";
import { Button } from "@vds/buttons";
import { ButtonIcon } from "@vds/button-icons";
import styled from "styled-components";
import { Icon } from "@vds/icons";
import axios from "axios";

const ButtonDiv = styled.div`
  display: block;
  top: calc(50% - 80px);
  transform: rotate(90deg);
  width: 44px;
  height: 58px;
`;

const MainDiv = styled.div`
  z-index: 9999;
  position: fixed;
  bottom: 60px;
  right: 20px;
  height: ${({ opened }) => (opened ? "495px" : "180px")};
  width: 350px;
  display: flex;
  width: ${({ opened }) => (opened ? "404px" : "50px")};
`;
const StyledButton = styled(Button)`
border-radius: 5px;
span{
    padding : 4px!important;
    transform: rotate(180deg);
  }
}
`;
const ChatAI = ({ repToolData }) => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const messagesEndRef = useRef(null);

  const triggerAPI = async (query) => {
    const apiUrl =
      "https://oa-uat.ebiz.verizon.com/vegas/apps/prompt/LLMInsight";
      const encodedApiKey = "SkRSQWJwMGl1T3Y2TzhmY2VmN3J5dzJXT3F6aFBTc0c="; // Base64-encoded API key
      const apiKey = atob(encodedApiKey);
      const payload = {
      useCase: "internationalplanner",
      contextId: "Zero_Shot_Testing",
      preSeed_injection_map: {
        "{Context}": repToolData,
        "{Question}": query,
      },
    };

    try {
      const response = await axios.post(apiUrl, payload, {
        headers: {
          "X-apikey": `${apiKey}`,
          "Content-Type": "application/json",
        },
      });

      const botResponse = response?.data?.prediction;
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: botResponse, isUser: false },
      ]);
    } catch (e) {
      console.error("Chatbot Error:", e);
    }
  };

  const handleSendMessage = () => {
    if (input.trim() === "") return;

    const userMessage = { text: input.trim(), id: Date.now(), isUser: true };

    setMessages((prevMessages) => [...prevMessages, userMessage]);

    const updatedInput = `${input.trim()} Please take out the * from response.`;

    triggerAPI(updatedInput);

    setInput("");
  };

  const handleInputChange = (event) => {
    setInput(event.target.value);
  };
  const handleKeyDown = (e) => {
    if (e?.key === "Enter") {
      handleSendMessage();
    }
  };
  useEffect(() => {
    if (
      messagesEndRef?.current &&
      typeof messagesEndRef?.current?.scrollIntoView === "function"
    ) {
      messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  return (
    <MainDiv opened={isOpen}>
      <ButtonDiv>
        <StyledButton
          onClick={() => {
            setIsOpen(true);
            setMessages((prevMessages) => [
              ...prevMessages,
              { isUser: false, text: "How can I help you?" },
            ]);
          }}
        >
          RepAssist
        </StyledButton>
      </ButtonDiv>
      {isOpen && (
        <div className="chat-container">
          <button
            className="close-chat-button"
            onClick={() => setIsOpen(false)}
          >
            ✕
          </button>
          <div className="chat-box">
            {messages?.map((msg) => (
              <div
                key={msg?.id}
                className={`message ${
                  msg?.isUser ? "user-message" : "bot-message"
                }`}
              >
                {msg?.isUser ? (
                  msg?.text
                ) : (
                  <div className="bot-response">
                    {msg?.text?.split("\n").map((line) => (
                      <p key={msg?.id} style={{ margin: "5px 0" }}>
                        {" "}
                        {line}
                      </p>
                    ))}

                    <div ref={(el) => (messagesEndRef.current = el)}></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="input-container">
            <input
              type="text"
              value={input}
              onChange={handleInputChange}
              placeholder="Type your message..."
              className="chat-input"
              onKeyDown={handleKeyDown}
            />
            <ButtonIcon
              onClick={handleSendMessage}
              kind="highContrast"
              size="large"
              renderIcon={() => (
                <Icon name="send-message" size="large" color="white" />
              )}
              className="send-button-icon"
            />
          </div>
        </div>
      )}
    </MainDiv>
  );
};

export default ChatAI;
